module.exports = __webpack_public_path__ + "static/img/pointofsale.a9e745d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pointofsale.png
// module id = 1059
// module chunks = 32